import { Box, Card, CardContent, Grid, Typography, CircularProgress } from '@mui/material';
import { useFetchTicketResumen } from '@/shared/actions/erp/tickets-soporte-cliente';

interface ContadoresEstadoProps {
  area?: string;
  usuarioAsignado?: string;
  onEstadoClick?: (codigoEstado: string) => void;
  estadoActivo?: string;
}

export default function ContadoresEstado({ area, usuarioAsignado, onEstadoClick, estadoActivo }: ContadoresEstadoProps) {
  const { data, isLoading } = useFetchTicketResumen({ area, usuario_asignado: usuarioAsignado });
  const resumen = data?.data;

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (!resumen) return null;

  const estados: { codigo: string; nombre: string; color: string; cantidad: number }[] = resumen.estados || [];

  return (
    <Box sx={{ mb: 2 }}>
      <Grid container spacing={1.5}>
        <Grid item xs={6} sm={4} md={1.7}>
          <Card
            sx={{
              bgcolor: !estadoActivo ? '#1565c0' : '#1976d2',
              color: '#fff',
              cursor: 'pointer',
              transition: 'all 0.2s',
              border: !estadoActivo ? '2px solid #0d47a1' : '2px solid transparent',
              '&:hover': { transform: 'translateY(-2px)', boxShadow: 4 },
            }}
            onClick={() => onEstadoClick?.('')}
          >
            <CardContent sx={{ py: 1.5, px: 2, '&:last-child': { pb: 1.5 } }}>
              <Typography variant="h4" fontWeight="bold" textAlign="center">
                {resumen.total}
              </Typography>
              <Typography variant="caption" textAlign="center" display="block" fontWeight={500}>
                Total
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        {estados.map((item) => {
          const isActive = estadoActivo === item.codigo;
          return (
            <Grid item xs={6} sm={4} md={1.7} key={item.codigo}>
              <Card
                sx={{
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  border: isActive ? `2px solid ${item.color}` : '2px solid transparent',
                  bgcolor: isActive ? `${item.color}15` : 'background.paper',
                  '&:hover': { transform: 'translateY(-2px)', boxShadow: 3, borderColor: item.color },
                }}
                onClick={() => onEstadoClick?.(item.codigo)}
              >
                <CardContent sx={{ py: 1.5, px: 2, '&:last-child': { pb: 1.5 } }}>
                  <Typography variant="h4" fontWeight="bold" textAlign="center" color={item.color}>
                    {item.cantidad}
                  </Typography>
                  <Typography variant="caption" textAlign="center" display="block" noWrap fontWeight={500}>
                    {item.nombre}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
